<template>
    <div class="div-wrapper">

        <div class="top-div d-flex justify-content-between align-items-start pb-3 mb-3">
            <div style="width: 100%;">
                <h5 class=" mb-2" style="color: #0055A6; font-weight: bolder;">{{ $t("summaryEvents") }}</h5>
                <div class="d-flex justify-content-between align-items-start col-8" style="padding-left: 0;">
                    <p class="text-muted mb-2">
                        {{ $t('tooltips.headers.summaryEventsHeader') }}
                    </p>
                </div>
            </div>
            <div class="align-self-center">
                <button v-if="items.length > 0" type="button" class="actions-btn" @click="menu.toggle($event)">
                    <span class="label">{{ $t("actions2") }}</span>
                    <span class="divider"></span>
                    <i :class="['chevron', isMenuOpen ? 'pi pi-chevron-up' : 'pi pi-chevron-down']"></i>
                </button>
                <Menu ref="menu" :model="templatePolicy ? template_items : items" :popup="true" @show="isMenuOpen = true" @hide="isMenuOpen = false" />
            </div>
        </div>
        <div>
            <div class="d-flex justify-content-end gap-3 mb-3">
                <Button class="custom-icon-button" @click="showEdit($t('addNewRule'), SummaryEventRuleForm, 'add')">
                    <i class="ag-icon ag-icon_add_icon"></i>
                    <span class="label-text">{{ $t("addNewRule") }}</span>
                </Button>
            </div>
            <div class="table-border-div" style="">
                <TabsFilter v-model:search="searchQuery" @clear="clearSearch"
                :totalRules="filteredSummaryEventsRows.length" type="summaryEvents" />
               <div class="d-flex align-items-center px-2 mb-4" >  <i class="ag-icon ag-icon_table_info_filled small"/><span  style="color: #0055A6; font-size: 12px; font-weight: 600; margin-left: 5px;">{{ $t("summaryEventOrderInfo") }}</span></div>
                <ag-card
                    v-if="summaryEventsModule && summaryEventsModule.component"
                    :key="tableKey"
                    :module="{ ...summaryEventsModule, component: { ...summaryEventsModule.component, options: { ...summaryEventsModule.component.options , rows: filteredSummaryEventsRows } } }"
                    @edit="(rowData) => editFunction2(rowData)" @deleteClick="(rowData) => deleteSummaryEvents(rowData)"
                    @copyClick="(rowData) => copyFunction(rowData)">
                </ag-card>
            </div>
        </div>
    </div>
    <EditPanel :show-enabled="true" v-model="showPanel" :title="formTitle" :form-component="formFileName" :form-type="formType"
        v-model:form="formModel" @save="saveHandler"/>
    <ag-loading v-if="loading" />
</template>
<script setup>

import { ref, computed, onMounted, watch, nextTick } from 'vue'
import SummaryEventsList from "@/helpers/pages/SummaryEvents/SummaryEventsList.ts";
import AgCard from "@/components/ag-card/index.vue";
import { useStore } from "@/store";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import TabsFilter from '@/components/ag-tabs-filter/index.vue';
import { GeneralActionTypes } from '@/store/modules/general/action-types';
import EditPanel from '@/components/ag-edit-panel/index.vue'
import SummaryEventRuleForm from '@/components/ag-edit-panel/forms/summary-event-rule-form.vue'
import Sortable from 'sortablejs';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const store = useStore();
let summaryEventsModule = ref(SummaryEventsList)
let searchQuery = ref('');
const menu = ref();
const isMenuOpen = ref(false);
const templatePolicy = ref(false);
const templateId = ref(null);
const loading = ref(false);
const localRows = ref([]);
const tableKey = ref(0);
const showPanel = ref(false);
const formTitle = ref(t('addNewRule'));
const formFileName = ref(SummaryEventRuleForm);
const formModel = ref({});
const formType = ref('summaryEventRule');
const summaryEventDetail = ref({});
const summaryEventRules = computed(() => store.state.general.summaryEventRules || []);
const summaryEventInfo = computed(() => store.state.general.summaryEventInfo || {});
const inheritanceInfo = computed(() => store.state.general.inheritanceInfo || {});
const items = computed(() => [
    { label: t('export'), command: () => doAction('export') },
    { label: t('import'), command: () => doAction('import')},
    { label: t('resetToDefault'), command: () => doAction('reset'), disabled: inheritanceInfo.value.isInherited === true }
]);
const summaryEventEntityData =  computed(() => store.state.general.summaryEventEntityData);
let summaryEventIsDefault = computed(() => summaryEventEntityData.value?.templatePolicyViewModel.isDefault);
const template_items = computed(() => [
    { label: t('resetToDefault'), command: () => doAction('reset'), disabled: summaryEventIsDefault.value === true }
]);

const clearSearch = () => {
    searchQuery.value = '';
}

const filteredSummaryEventsRows = computed(() => {
    const query = searchQuery.value.toLowerCase();
    const rows = localRows.value.length > 0 ? localRows.value : summaryEventRules.value || [];

    if (!query) return rows;

    return rows.filter(row => {
        // Rule Name, Event Type
        const matchesRuleName = row.ruleName?.toLowerCase().includes(query) || false;
        const matchesEventType = row.eventType?.toLowerCase().includes(query) || false;
        
        // Conditions
        const matchesConditions = row.conditions?.some(
            condition => condition.condition?.toLowerCase().includes(query)
        ) || false;
        
        // Group By Fields
        const matchesGroupByFields = row.groupByFields?.some(
            field => field.elementName?.toLowerCase().includes(query)
        ) || false;

        return matchesRuleName || matchesEventType || matchesConditions || matchesGroupByFields;
    });
});


watch(summaryEventRules, (newRules) => {
    localRows.value = [...newRules];
    if (summaryEventsModule.value?.component?.options) {
        summaryEventsModule.value.component.options.rows = newRules;
        summaryEventsModule.value.component.options.total = newRules.length;
        summaryEventsModule.value.component.options.isLoading = false;
    }
    nextTick(() => {
        initDragDrop();
    });
}, { immediate: true });

watch(() => localRows.value.length, () => {
    if (summaryEventsModule.value?.component?.options) {
        summaryEventsModule.value.component.options.rows = [...localRows.value];
    }
});

watch(() => localRows.value.map(r => r.id).join(','), () => {
    if (summaryEventsModule.value?.component?.options) {
        summaryEventsModule.value.component.options.rows = [...localRows.value];
        tableKey.value++;
        
        nextTick(() => {
            const table = document.querySelector('#ag-table tbody');
            if (table) {
                table.classList.remove('sortable-initialized');
                initDragDrop();
            }
        });
    }
});

const initDragDrop = () => {
    const table = document.querySelector('#ag-table tbody');
    if (table && !table.classList.contains('sortable-initialized')) {
        table.classList.add('sortable-initialized');
        Sortable.create(table, {
            animation: 200,
            handle: '.drag-handle',
            ghostClass: 'sortable-ghost',
            chosenClass: 'sortable-chosen',
            dragClass: 'sortable-drag',
            onEnd: async (evt) => {
                const oldIndex = evt.oldIndex;
                const newIndex = evt.newIndex;
                
                if (oldIndex !== undefined && newIndex !== undefined && oldIndex !== newIndex) {
                    const movedItem = localRows.value.splice(oldIndex, 1)[0];
                    localRows.value.splice(newIndex, 0, movedItem);
                    await saveNewOrder();
                }
            }
        });
    }
};
const saveNewOrder = async () => {
    try {
        const group = localStorage.getItem("agms_group");
        const groupId = group ? JSON.parse(group)?.mainid : null;
        const summaryEventsId = summaryEventInfo.value?.id;
        const orderedRuleIds = localRows.value.map(row => row.id);
        const payload = {
            summaryEventsId: summaryEventsId,
            ruleIdsInOrder: orderedRuleIds
        };
        
        
        const template = localStorage.getItem("agms_template");
        const templateId = template ? JSON.parse(template)?.mainid : null;
        if (templatePolicy.value) {
            payload.templateId = templateId;
            await store.dispatch(GeneralActionTypes.REORDER_SUMMARY_EVENT_RULES_TEMPLATE, payload);
            await getSummaryEventInheritanceInfo(null, templateId);
            await getTemplateSummaryEventsList();
        } else {
            payload.groupId = groupId;
            await store.dispatch(GeneralActionTypes.REORDER_SUMMARY_EVENT_RULES, payload);
            await getSummaryEventInheritanceInfo(groupId, null);
            await getSummaryEventsList();
        }
    } catch (error) {
        console.error('Failed to save new order:', error);
    }
};

const editFunction2 = async (rowData) => {
    await getSummaryEventDetail('edit', rowData.id);
}

const deleteSummaryEvents = async (rowData) => {
    try {
        const result = await Swal.fire({
            title: t('areYouSure'),
            text: t('deleteSummaryEventConfirm'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('delete'),
            cancelButtonText: t('cancel')
        });

        if (result.isConfirmed) {
            loading.value = true;
            const group = localStorage.getItem("agms_group");
            const groupId = group ? JSON.parse(group)?.mainid : null;   

            const payload = {
                id: rowData.id,
                summaryEventsId: rowData.summaryEventsId
            };
            if(templatePolicy.value) {
                const templateStr = localStorage.getItem("agms_template");
                const mainId = templateStr ? JSON.parse(templateStr)?.mainid : null;
                templateId.value = mainId;
                payload.templateId = templateId.value;
                payload.conditions= [];
                payload.groupByFields= [];
            }

            const actionType = templatePolicy.value 
                ? GeneralActionTypes.DELETE_SUMMARY_EVENT_RULE_TEMPLATE 
                : GeneralActionTypes.DELETE_SUMMARY_EVENT_RULE;

            const response = await store.dispatch(actionType, payload);
            
            if (response.isSuccess) {
                await Swal.fire({
                    title: t('deleted'),
                    text: t('summaryEventDeletedSuccess'),
                    icon: 'success',
                    confirmButtonText: t('ok')
                });
                if(templatePolicy.value) {
                    await getTemplateSummaryEventsList();
                } else {
                    await getSummaryEventsList();
                }
            } else {
                await Swal.fire({
                    title: t('error'),
                    text: response.message || t('anErrorOccurred'),
                    icon: 'error',
                    confirmButtonText: t('ok')
                });
            }
        }
    } catch (error) {
        await Swal.fire({
            title: t('error'),
            text: t('anErrorOccurred'),
            icon: 'error',
            confirmButtonText: t('ok')
        });
    } finally {
        loading.value = false;
    }
}

const copyFunction = async (rowData) => {
    await getSummaryEventDetail('copy', rowData.id);
}

const doAction = async (action) => {
    if (action === 'reset') {
        await resetSummaryEvents();
    } else if (action === 'export') {
        await exportSummaryEvents();
    } else if (action === 'import') {
        await importSummaryEvents();
    }
};

const resetSummaryEvents = async () => {
    try {
        const result = await Swal.fire({
            title: t('areYouSure'),
            text: t('thisWillResetAllSummaryEventsToDefault'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('reset'),
            cancelButtonText: t('cancel')
        });

        if (result.isConfirmed) {
            loading.value = true;
            const group = localStorage.getItem("agms_group");
            const groupId = group ? JSON.parse(group)?.mainid : null;
            
            const summaryEventsId = summaryEventInfo.value?.id;
            
            if (!summaryEventsId) {
                await Swal.fire({
                    title: t('error'),
                    text: t('summaryEventsIdNotFound'),
                    icon: 'error',
                    confirmButtonText: t('ok')
                });
                return;
            }

            const payload = {
                summaryEventsId: summaryEventsId
            };
            let response = null;
            if(templatePolicy.value) {
                payload.templatePolicy = templatePolicy.value;
                const templateStr = localStorage.getItem("agms_template");
                const mainId = templateStr ? JSON.parse(templateStr)?.mainid : null;
                templateId.value = mainId;
                payload.templateId = templateId.value;
                response = await store.dispatch(GeneralActionTypes.RESET_SUMMARY_EVENTS_TEMPLATE, payload);
            } else {
                payload.groupId = groupId;
                response = await store.dispatch(GeneralActionTypes.RESET_SUMMARY_EVENTS, payload);
            }

            if (response.isSuccess) {
                await Swal.fire({
                    title: t('success'),
                    text: t('summaryEventsResetSuccessfully'),
                    icon: 'success',
                    confirmButtonText: t('ok')
                });
                if(templatePolicy.value) {
                    await getTemplateSummaryEventsList();
                } else {
                    await getSummaryEventsList();
                }
            } else {
                await Swal.fire({
                    title: t('error'),
                    text: response.message || t('anErrorOccurred'),
                    icon: 'error',
                    confirmButtonText: t('ok')
                });
            }
        }
    } catch (error) {
        await Swal.fire({
            title: t('error'),
            text: t('anErrorOccurred'),
            icon: 'error',
            confirmButtonText: t('ok')
        });
    } finally {
        loading.value = false;
    }
};

const exportSummaryEvents = async () => {
    try {
        loading.value = true;
        const group = localStorage.getItem("agms_group");
        const groupId = group ? JSON.parse(group)?.mainid : null;
        
        const exportOptions = {
            groupId: groupId
        };
        
        const blob = await store.dispatch(GeneralActionTypes.EXPORT_SUMMARY_EVENTS, exportOptions);
        
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `summary_events_${groupId}_${new Date().getTime()}.json`;
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        await Swal.fire({
            title: t('success'),
            text: t('summaryEventsExportedSuccessfully'),
            icon: 'success',
            confirmButtonText: t('ok')
        });
    } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || t('anErrorOccurred');
    } finally {
        loading.value = false;
    }
};

const importSummaryEvents = async () => {
    try {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.json';
        const group = localStorage.getItem("agms_group");
        const groupId = group ? JSON.parse(group)?.mainid : null;
        
        input.onchange = async (e) => {
            const file = e.target.files[0];
            if (!file) return;
            
            try {
                loading.value = true;
                const text = await file.text();
                const data = JSON.parse(text);
                
                data.targetGroupId = groupId;
 
                const response = await store.dispatch(GeneralActionTypes.IMPORT_SUMMARY_EVENTS, data);
                
                if (response.isSuccess) {
                    await Swal.fire({
                        title: t('success'),
                        text: t('summaryEventsImportedSuccessfully'),
                        icon: 'success',
                        confirmButtonText: t('ok')
                    });
                    
                    await getSummaryEventsList();
                } else {
                    const errorMessage = response.message || response.errorMessage || response.errors?.[0] || t('anErrorOccurred');
                    await Swal.fire({
                        title: t('error'),
                        text: errorMessage,
                        icon: 'error',
                        confirmButtonText: t('ok')
                    });
                }
            } catch (error) {
                const errorMessage = error.response?.data?.message || error.response?.data?.errorMessage || error.message || t('invalidFileFormat');
                await Swal.fire({
                    title: t('error'),
                    text: errorMessage,
                    icon: 'error',
                    confirmButtonText: t('ok')
                });
            } finally {
                loading.value = false;
            }
        };
        
        input.click();
    } catch (error) {
        console.error('Import error:', error);
    }
}

async function getSummaryEventsList() {
    const group = localStorage.getItem("agms_group");
    const groupId = group ? JSON.parse(group)?.mainid : null;
    try {
        const response = await store.dispatch(GeneralActionTypes.GET_SUMMARY_EVENTS_LIST, groupId);
    } finally {
        summaryEventsModule.value.component.options.isLoading = false;
        getSummaryEventInheritanceInfo(groupId,null);

    }
}
async function getTemplateSummaryEventsList() {
    const template = localStorage.getItem("agms_template");
  const templateId = template ? JSON.parse(template)?.mainid : null;
    try {
        const response = await store.dispatch(GeneralActionTypes.GET_SUMMARY_EVENTS_LIST_TEMPLATE, templateId);
    } finally {
        summaryEventsModule.value.component.options.isLoading = false;
        getSummaryEventInheritanceInfo(null,templateId);
    }
}
async function getSummaryEventInheritanceInfo(groupId,templateId) {
    const summaryEventId = summaryEventInfo.value.id;
    await store.dispatch(GeneralActionTypes.GET_SUMMARY_EVENT_INHERITANCE_INFO, {summaryEventId:summaryEventId, groupId: groupId,templateId: templateId});
}

onMounted(() => {
    const routeName = useRoute().name;
    if (routeName == 'templateSummaryEvents') {
        const templateStr = localStorage.getItem("agms_template");
        const mainId = templateStr ? JSON.parse(templateStr)?.mainid : null;
        templateId.value = mainId;
        templatePolicy.value = true;
        getTemplateSummaryEventsList();
    } else {
        getSummaryEventsList();
    }

    nextTick(() => {
        initDragDrop();
    });
});
function showEdit(title, formName, type, data = {}) {
    let formData = {};

    if (type === "add") {
        formData = {
            ruleName: '',
            eventType: null,
            groupByFields: [{ elementName: null, level: null }],
            conditions: [{ elementName: null, condition: null, value: '', level: null }],
            notes: '',
            enabled: true
        };
    } else if (type === "edit") {
        formData = {
            ...data,
            groupByFields: (data.groupByFields || []).map(field => ({
                id: field.id,
                elementName: field.elementName,
                level: field.level !== null && field.level !== undefined ? String(field.level) : null
            })),
            conditions: (data.conditions || []).map(cond => ({
                id: cond.id,
                elementName: cond.elementName,
                condition: cond.condition,
                value: cond.value,
                level: cond.level !== null && cond.level !== undefined ? String(cond.level) : null
            })),
            notes: data.notes || ''
        };
    } else if (type === "copy") {
        formData = {
            ...data,
            groupByFields: (data.groupByFields || []).map(field => ({
                elementName: field.elementName,
                level: field.level !== null && field.level !== undefined ? String(field.level) : null
            })),
            conditions: (data.conditions || []).map(cond => ({
                elementName: cond.elementName,
                condition: cond.condition,
                value: cond.value,
                level: cond.level !== null && cond.level !== undefined ? String(cond.level) : null
            })),
            notes: data.notes || ''
        };
        delete formData.id;
        delete formData.summaryEventsId;
    }

    formModel.value = formData;
    formTitle.value = title;
    formFileName.value = formName;
    showPanel.value = true;
    formType.value = 'summaryEventRule';
}

const getSummaryEventDetail = async (type, ruleId) => {
    try {
        const ruleData = localRows.value.find(r => r.id === ruleId);
        if (ruleData) {
            summaryEventDetail.value = ruleData;
            if (type === 'edit') {
                showEdit(t('editRule'), SummaryEventRuleForm, 'edit', summaryEventDetail.value);
            } else if (type === 'copy') {
                showEdit(t('addNewRule'), SummaryEventRuleForm, 'copy', summaryEventDetail.value);
            }
        }
    } catch (error) {
        console.error("Summary Event detail fetch error:", error);
    }
};

const saveHandler = async (dataFromForm) => {
    const group = localStorage.getItem("agms_group");
    const groupId = group ? JSON.parse(group)?.mainid : null;
    
    const summaryEventsId = summaryEventInfo.value?.id || null;
    
    let body = {
        id: dataFromForm.id || 0,
        summaryEventsId: summaryEventsId,
        ruleName: dataFromForm.ruleName,
        eventType: dataFromForm.eventType,
        sortOrder: dataFromForm.sortOrder || 0,
        groupByFields: (dataFromForm.groupByFields || []).map(field => ({
            id: field.id || 0,
            ruleId: dataFromForm.id || 0,
            elementCategory: dataFromForm.eventType,
            elementName: field.elementName,
            level: field.level
        })),
        conditions: (dataFromForm.conditions || []).map(cond => ({
            id: cond.id || 0,
            ruleId: dataFromForm.id || 0,
            elementCategory: dataFromForm.eventType,
            elementName: cond.elementName,
            condition: cond.condition,
            value: cond.value,
            level: cond.level
        })),
        notes: dataFromForm.notes || '',
        enabled: dataFromForm.enabled !== undefined ? dataFromForm.enabled : true
    };

    if (!body.ruleName || !body.eventType) {
        await Swal.fire({
            title: t('warning'),
            html: t('summaryEventFilledWarm'),
            icon: "warning",
            confirmButtonText: t('ok'),
        });
        return;
    }

    body.groupByFields = body.groupByFields.filter(field => 
        field.elementName || field.level
    );
    
    body.conditions = body.conditions.filter(cond => 
        cond.elementName || cond.condition || cond.value || cond.level
    );

    await createOrUpdateRule(body);
};

const createOrUpdateRule = async (body) => {
    try {
        loading.value = true;
        let response = null;

        if (templatePolicy.value) {
            body.templateId = templateId.value;
            response = await store.dispatch(
                GeneralActionTypes.CREATE_OR_UPDATE_SUMMARY_EVENT_RULE_TEMPLATE,
                body
            );
        } else {
            response = await store.dispatch(
                GeneralActionTypes.CREATE_OR_UPDATE_SUMMARY_EVENT_RULE,
                body
            );
        }

        if (response?.isSuccess) {
            showPanel.value = false;

            const successMsg = body.id === 0
                ? t('summaryEventRuleAddedSuccessfully')
                : t('summaryEventRuleUpdatedSuccessfully');

            await Swal.fire({
                title: t('success'),
                text: successMsg,
                icon: 'success',
                confirmButtonText: t('ok')
            });

            if (templatePolicy.value) {
                await getTemplateSummaryEventsList();
            } else {
                await getSummaryEventsList();
            }
        } else {
            loading.value = false;

            const isDuplicate =
        response?.messageKey === 'duplicateRule' ||
        response?.errors?.includes('DuplicateRule');

        await Swal.fire({
            title: t('error'),
            html: isDuplicate
                ? buildDuplicateRuleMessage(response.conflict)
                : (response?.message
                    || (Array.isArray(response?.errors) && response.errors[0])
                    || t('anErrorOccurred')),
            icon: 'error',
            confirmButtonText: t('ok')
            });
        }
    } catch (error) {
        console.error('Create/Update error:', error);
        const apiMessage =
            error?.response?.data?.message ||
            (Array.isArray(error?.response?.data?.errors) && error.response.data.errors[0]) ||
            error?.message ||
            t('anErrorOccurred');

        loading.value = false;

        await Swal.fire({
            title: t('error'),
            text: apiMessage,
            icon: 'error',
            confirmButtonText: t('ok')
        });
    } finally {
        loading.value = false;
    }
};
const buildDuplicateRuleMessage = (conflict) => {
    if (!conflict) return t('anErrorOccurred');

    if (conflict.conflictType === 'NameAndEventType') {
        return t('summaryEventDuplicateRule.nameAndEventType', {
            ruleName: conflict.conflictingRuleName,
            eventType: conflict.eventType,
        });
    }

    if (conflict.conflictType === 'ContentMatch') {
        const baseMsg = t('summaryEventDuplicateRule.contentMatch', {
            ruleName: conflict.conflictingRuleName,
            eventType: conflict.eventType,
        });

        const conditionsText = (conflict.conditions || [])
            .map(c => `${c.elementCategory}/${c.elementName} ${c.condition} '${c.value}'`)
            .join(', ');

        const groupByText = (conflict.groupByFields || [])
            .map(g => `${g.elementCategory}/${g.elementName}`)
            .join(', ');

        return `
            ${baseMsg}
            <br/><br/>
            <b>${t('summaryEventDuplicateRule.conditionsLabel')}:</b> ${conditionsText}
            <br/>
            <b>${t('summaryEventDuplicateRule.groupByLabel')}:</b> ${groupByText}
        `;
    }

    return t('anErrorOccurred');
};
</script>

<style scoped>
.text-muted {
    border-bottom: 1px solid #D2D9E2;
    padding-bottom: 5px;
    padding-left: 0;
    color: #01172F !important;
    font-size: 0.8em;
}

.btn-light {
    background-color: #e1eaf4;
    color: #0b4c8c;
}

.custom-icon-button {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: transparent;
    border: none;
    box-shadow: none;
    color: #2c5f89;
    font-weight: bold;
    text-transform: uppercase;
    padding: 0;
    font-size: 0.8rem;
}

.custom-icon-button:hover {
    opacity: 0.8;
    cursor: pointer;
}

.icon-circle {
    background-color: #2c5f89;
    color: white;
    border-radius: 50%;
    padding: 8px;
    font-size: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.detail-edit-icon {
    width: 20px;
    height: 20px;
}

.table-border-div {
    border-top: 1px solid #D2D9E2;
    border-left: 1px solid #D2D9E2;
    border-right: 1px solid #D2D9E2;
    padding-top: 15px;
}

.actions-btn {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    background-color: #0C4F93;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    padding: 8px 12px;
    font-weight: 600;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    min-width: 12.5rem;
}

.actions-btn .label {
    font-size: 0.95rem;
}

.actions-btn .divider {
    width: 1px;
    height: 18px;
    background: rgba(255, 255, 255, 0.6);
    margin-left: auto;
}

.actions-btn .chevron {
    color: #ffffff;
    font-size: 0.9rem;
}

.actions-btn:hover {
    opacity: 0.95;
}

.label-text {
    color: #3C73AA;
}

/* Drag-Drop Styles */
.drag-handle {
    cursor: move;
    user-select: none;
    padding: 5px;
    display: inline-block;
}

.drag-handle:hover {
    color: #0C4F93 !important;
}

.sortable-ghost {
    opacity: 0.4;
    background-color: #e3f2fd !important;
}

.sortable-chosen {
    background-color: #f5f5f5 !important;
}

.sortable-drag {
    opacity: 0.8;
}

.top-div {
  background-color: #fff;
  margin-left: -25px;
  margin-right: -15px;
  margin-top: -23px;
  margin-bottom: 40px;
  padding:30px 20px;
}
/* :deep(#ag-table) {
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
} */

:deep(#ag-table thead th > div) {
  color: #5D5F62;
  font-weight: 700;
}
:deep(#ag-table tbody tr) {
    transition: background-color 0.2s;
}
:deep(#ag-table thead th:first-child) {
  border-right: none !important;
}
:deep(#ag-table thead th:nth-child(2)) {
  border-left: none !important;
}
:deep(#ag-table thead th:first-child),
:deep(#ag-table tbody td:first-child) {
  width: 20px !important;
  max-width: 20px !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
}

:deep(.ag-card .ag-card_body) {
  border: none !important;
}

:deep(#ag-table .table tbody td:nth-child(3) div:not(.vjs-tree)) {
  display: block !important;
}
</style>

<style>
.p-menu {
  border: 1px solid #D2D9E2 !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12) !important;
  border-radius: 10px !important;
  overflow: hidden;
}

.p-menu .p-menuitem-link {
  padding: 0.75rem 1rem !important;
  color: #0B1736 !important;
  font-weight: 600;
}

.p-menu .p-menuitem-link .p-menuitem-icon {
  margin-right: 0.5rem;
}

.p-menu .text-danger {
  color: #C62828 !important;
}
</style>